import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles, Dialog, DialogTitle, DialogContent, IconButton, DialogActions, Typography} from '@material-ui/core';
import {Close as CloseIcon} from '@material-ui/icons';

const useStyles = makeStyles({
  dialogTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  dialogContent: {
    overflowY: 'visible',
  },
  closeButton: {
    padding: 4,
  },
  closeIcon: {
    fontSize: 30,
  },
});

const Modal = ({
  title,
  open,
  onClose,
  fullWidth,
  fullScreen,
  maxWidth,
  scroll,
  renderContent,
  renderActions,
  ...restProps
}) => {
  const classes = useStyles();
  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={onClose}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      scroll={scroll}
      {...restProps}
    >
      <DialogTitle disableTypography className={classes.dialogTitle}>
        <Typography variant="h5" color="primary">
          {title}
        </Typography>
        <IconButton onClick={onClose} className={classes.closeButton}>
          <CloseIcon color="primary" className={classes.closeIcon} />
        </IconButton>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>{open && renderContent && renderContent()}</DialogContent>
      <DialogActions className={classes.dialogActions}>{renderActions && renderActions()}</DialogActions>
    </Dialog>
  );
};

Modal.propTypes = {
  title: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  fullWidth: PropTypes.bool.isRequired,
  fullScreen: PropTypes.bool.isRequired,
  maxWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', false]).isRequired,
  disableBackdropClick: PropTypes.bool.isRequired,
  scroll: PropTypes.string.isRequired,
  renderContent: PropTypes.func,
  renderActions: PropTypes.func,
};

Modal.defaultProps = {
  open: false,
  fullWidth: true,
  fullScreen: false,
  maxWidth: 'sm',
  disableBackdropClick: true,
  scroll: 'body',
};

export default Modal;
